/**
 * The address to open for an institution's `website`, or null when there is nothing to open.
 *
 * The column is free text and holds three kinds of thing. A full address is used as it stands. A
 * bare domain — "institut-test.md", which is how people write one — is an address that a browser
 * needs a scheme for: without one the anchor is relative and lands inside the app, so the scheme is
 * added rather than the value being demoted to text. And the development data has an institution
 * whose website reads "home", which is not an address at all and gets no link.
 *
 * Shared by the cabinet header and the public profile, which show the same field to two readers:
 * the guard existed on the public page alone, so the institution's own screen was the one place
 * the broken link was still offered.
 */
export function websiteHref(website: string | null | undefined): string | null {
  const value = website?.trim();
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  // A hostname with at least one dot and no whitespace — enough to tell "institut-test.md" from
  // "home" without trying to validate a domain, which is not this function's business.
  return /^[\w-]+(\.[\w-]+)+(\/\S*)?$/.test(value) ? `https://${value}` : null;
}
